'use client'

import { CSSProperties, ReactNode, useContext, useEffect } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import classNames from 'classnames'

import SortContext from './SortContext'

type Props = {
  id: number | string
  index: number
  className?: string
  children: ReactNode
}

const Item = ({ id, index, className, children }: Props) => {
  const idString = String(id)
  const { addItem, removeItem } = useContext(SortContext)
  const { active, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: idString,
  })

  useEffect(() => addItem(idString, index), [addItem, idString, index])
  useEffect(() => () => removeItem(idString), [idString, removeItem])

  const isActive = active?.id === idString
  const style: CSSProperties = {}

  if (active) {
    style.transition = transition

    if (transform) {
      const translateX = Math.round(transform.x)
      const translateY = Math.round(transform.y)

      style.transform = `translate(${translateX}px, ${translateY}px) scaleX(${transform.scaleX}) scaleY(${transform.scaleY})`
    }
  }

  return (
    <div
      {...attributes}
      {...listeners}
      ref={setNodeRef}
      style={style}
      className={classNames(className, {
        'u-auto-pointer-events u-cursor-grabbing u-disabled u-position-relative u-zindex-bump':
          isActive,
        'u-cursor-grab': !isActive,
      })}
    >
      {children}
    </div>
  )
}

export default Item
